<template>
  <div ref="reference" class="appointment-card">
    <h4 class="appointment-card-title">{{ data.parkingLotNo }}</h4>
    <div
      v-for="(item, index) in cardList"
      :key="index"
      class="appointment-card-item"
    >
      <label class="appointment-card-label">{{ $t(`deliveryappointment.urgentreservation.${item}`) }}</label>
      <div class="appointment-card-value">{{ data[item] }}</div>
    </div>
    <div class="appointment-card-item" :class="{ 'is-hide': !selfSelection.length }">
      <label class="appointment-card-label">{{ $t(`deliveryappointment.urgentreservation.checked`) }}</label>
      <div class="appointment-card-value">
        <span>{{ selectionText }}</span>
      </div>
    </div>
    <div class="appointment-card-btnbox">
      <el-button style="width: 80px;" :type="selfSelection.length ? 'primary' : 'default'" @click="showPopper = true">
        {{ selfSelection.length ? $t('deliveryappointment.urgentreservation.hasappointment') : $t('deliveryappointment.urgentreservation.appointmentnow') }}
      </el-button>
    </div>
    <transition name="el-zoom-in-top" @after-leave="doDestroy">
      <div v-show="showPopper" ref="popper" class="appointment-card-popper">
        <h5 class="appointment-card-choosetitle">请选择可预约时间段 <i class="iconfont icon-guanbi" @click="showPopper = false" /></h5>
        <div class="appointment-card-choosebox">
          <div class="appointment-time-box">
            <div class="appointment-time-label">上午</div>
            <div class="appointment-time-list">
              <button
                v-for="(item, index) in data.morningList"
                :key="index"
                class="appointment-time-item"
                :class="{ 'is-select': selectionMap.has(item.id) }"
                @click="chooseItem(item)"
              >{{ item.startTime }} - {{ item.endTime }}</button>
            </div>
          </div>

          <div class="appointment-time-box">
            <div class="appointment-time-label">下午</div>
            <div class="appointment-time-list">
              <button
                v-for="(item, index) in data.noonList"
                :key="index"
                class="appointment-time-item"
                :class="{ 'is-select': selectionMap.has(item.id) }"
                @click="chooseItem(item)"
              >{{ item.startTime }} - {{ item.endTime }}</button>
            </div>
          </div>

        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import Popper from 'element-ui/src/utils/vue-popper'
import { on, off } from 'element-ui/src/utils/dom'
const cardList = ['uploadPointName', 'remarks', 'purchaseUnitName', 'receiptWareName', 'master', 'phone']
export default {
  mixins: [Popper],
  props: {
    data: {
      type: Object,
      default: () => ({})
    },
    selection: {
      type: Array,
      default: () => []
    },
    selectionMap: {
      type: null,
      default: new Set()
    }
  },
  data() {
    return {}
  },
  computed: {
    cardList() {
      return cardList
    },
    selfSelection() {
      const selection = []
      this.data.morningList.forEach(item => {
        if (this.selectionMap.has(item.id)) {
          selection.push(item)
        }
      })
      this.data.noonList.forEach(item => {
        if (this.selectionMap.has(item.id)) {
          selection.push(item)
        }
      })
      return selection
    },
    selectionText() {
      return this.selfSelection.map(item => `${item.startTime}-${item.endTime}`).join(',')
    }
  },
  mounted() {
    on(document, 'click', this.handleDocumentClick)
  },
  beforeDestroy() {
    off(document, 'click', this.handleDocumentClick)
  },
  methods: {
    chooseItem(item) {
      if (this.selectionMap.has(item.id)) {
        const selection = [...this.selection]
        selection.splice(selection.indexOf(item.id), 1)
        if (this.selfSelection.length === 1) {
          this.$emit('change-car', this.data)
        }
        this.$emit('change', selection)
      } else {
        if (this.selfSelection.length === 0) {
          this.$emit('change-car', this.data)
        }
        this.$emit('change', [...this.selection, item.id])
      }
    },
    handleDocumentClick(e) {
      let reference = this.reference || this.$refs.reference
      const popper = this.popper || this.$refs.popper

      if (!reference && this.$slots.reference && this.$slots.reference[0]) {
        reference = this.referenceElm = this.$slots.reference[0].elm
      }
      if (!this.$el ||
        !reference ||
        this.$el.contains(e.target) ||
        reference.contains(e.target) ||
        !popper ||
        popper.contains(e.target)) return
      this.showPopper = false
    }
  }
}
</script>

<style lang="scss" scoped>
.appointment-card {
  width: calc(16.76% - 10px);
  height: 322px;
  background-color: #fff;
  margin-left: 10px;
  margin-bottom: 10px;
  padding: 0 17px;
  position: relative;
  box-sizing: border-box;
  &:nth-of-type(6n+1) {
    margin-left: 0;
  }

  &-title {
    padding: 23px 0 18px;
    color: #008ee3;
    font-size: 15px;
    font-weight: 600;
    margin: 0;
  }

  &-item {
    text-align: left;
    padding: 0;
    width: 100%;
    vertical-align: middle;
    margin: 10px 0;
    &.is-hide {
      visibility: hidden;
    }
  }

  &-label {
    min-width: 52px;
    line-height: 19px;
    text-align: left;
    color: #999;
    display: inline-block;
  }
  &-value {
    width: calc(100% - 72px);
    line-height: 19px;
    margin-left: 15px;
    color: #333;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    display: inline-block;
    vertical-align: top;
  }

  &-btnbox {
    margin-top: 10px;
    text-align: center;
  }

  &-popper {
    height: 322px;
    width: calc(200% + 20px);
    background: #fff;
    border-right: 1px solid #F3F5F6;
    border-left: 1px solid #F3F5F6;
  }

  &-choosetitle {
    color: #333;
    font-size: 13px;
    font-weight: 600;
    padding: 15px 15px 10px;
    margin: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
  }

  &-choosebox {
    padding: 10px 15px;
    box-sizing: border-box;
    height: calc(100% - 44px);
    overflow: auto;
  }
}
.appointment-time {
  &-box {
    display: flex;
    margin-bottom: 15px;
  }
  &-label {
    line-height: 30px;
    min-width: 30px;
    color: #666;
    margin-right: 10px;
  }
  &-list {
    flex-grow: 1;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  &-item {
    border: 1px solid #E1E1E1;
    background-color: transparent;
    line-height: 30px;
    font-size: 12px;
    color: #666;
    padding: 0 12px;
    margin: 0 3px;
    border-radius: 30px;
    margin-bottom: 10px;
    cursor: pointer;
    &.is-select {
      border-color: #008ee3;
      background-color: #008ee3;
      color: #fff;
    }
  }
}
</style>
